import {
  FechaMaximaPractica,
  FechaMinimaPractica,
} from 'store/practicas/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { State } from 'store/app/types';
import { ActionType } from 'typesafe-actions';
import ActionTypes from 'store/app/actionTypes';
import * as actions from 'store/app/actions';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { removeSecondsAndMilliseconds } from '../../utils/dateTimeUtils';

export const initialState: State = {
  error: '',
  username: '',
  password: '',
  // Create practice form
  dateMinSelected: {} as FechaMinimaPractica,
  dateMaxSelected: {} as FechaMaximaPractica,
  statePracticeSelected: '',
  selectedCourses: [],
  selectedSocieties: '',
  selectedAlumnos: [],
  profileSelected: 0,
  selectedProvince: [],
  practicaAuditoriaSeleccionada: '',
  practicaReclamadaSeleccionada: '',
  practicaRechazadaSeleccionada: '',
  creationSelected: '',
  selectedSchool: '',
  stateType: '',
  practicaEditar: '',
  msgSubmit: '',
  modalDraftType: '',
  practicaCreada: '',
  userList: '',
  observaciones_instructor: '',
  // alert
  alert: {
    modalType: '',
    message: '',
  },
  // loading
  loading: false,

  startJourneySelectedError: null,
  finishDateJourneySelectedError: null,
  finishTimeJourneySelectedError: null,
  startServiceSelectedError: null,
  finishDateServiceSelectedError: null,
  finishTimeServiceSelectedError: null,
  minutesPracticeSelectedError: null,
  minutesCESelected: null,
  minutesPendingCESelected: null,
  minutesOtherSelected: null,
  minutesPendingOtherSelected: null,
  minutesDraftSelected: null,
  minutesPreparationSelected: null,
  hourService: null,
  observacionesInstructorSelected: '',
  startJourneySelectedErrorDraft: null,
  finishDateJourneySelectedErrorDraft: null,
  finishTimeJourneySelectedErrorDraft: null,
  startServiceSelectedErrorDraft: null,
  finishDateServiceSelectedErrorDraft: null,
  finishTimeServiceSelectedErrorDraft: null,
  practiceValidSelect: '',
  startPreparationSelectedError: null,
  typePracticeSelected: '',
  infoUserProfileStatus: '',
  updateInfoUserProfileStatus: '',
  // Form crear práctica
  selectedJourney: null,
  startDateTimeSelectedJourney: null,
  startTimeSelectedJourneyPristine: true,
  finishDateTimeSelectedJourney: null,
  finishTimeSelectedJourneyPristine: true,
  startDateTimeSelectedPreparation: null,
  startTimeSelectedPreparationPristine: true,
  startDateTimeSelectedService: null,
  startTimeSelectedServicePristine: true,
  finishDateTimeSelectedService: null,
  finishTimeSelectedServicePristine: true,
  minutesPracticeSelected: null,
  stationSelected: null,
  destinySelected: null,
  selectedInstructors: [],
  observaciones_alumno: '',
  selectedCourse: '',
  idTypePracticeSelected: '',
  typeServiceSelected: '',
  disposicionPracticeSelected: '',
  vehicleSelected: '',
  trainSelected: '',
  turnSelected: '',
  isAuditar: 'false',
};

// TODO: Revisar el tipado del reducer

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    case ActionTypes.RESET_STATE:
      return initialState;
    case ActionTypes.RESET_CREATE_PRACTICE_FORM:
      return {
        ...state,
        error: state.error,
        msgSubmit: state.msgSubmit,
        modalDraftType: state.modalDraftType,
        username: state.username,
        password: state.password,
        profileSelected: state.profileSelected,
        // jorney, service, pd, minutes
        minutesPracticeSelectedError: initialState.minutesPracticeSelectedError,
        startServiceSelectedErrorDraft:
          initialState.startServiceSelectedErrorDraft,
        finishDateServiceSelectedErrorDraft:
          initialState.finishDateServiceSelectedErrorDraft,
        finishTimeServiceSelectedErrorDraft:
          initialState.finishTimeServiceSelectedErrorDraft,
        startPreparationSelectedError:
          initialState.startPreparationSelectedError,
        finishDateJourneySelectedError:
          initialState.finishDateJourneySelectedError,
        finishDateServiceSelectedError:
          initialState.finishDateServiceSelectedError,
        finishTimeJourneySelectedError:
          initialState.finishTimeJourneySelectedError,
        finishTimeServiceSelectedError:
          initialState.finishTimeServiceSelectedError,
        startJourneySelectedError: initialState.startJourneySelectedError,
        startServiceSelectedError: initialState.startServiceSelectedError,
        startJourneySelectedErrorDraft:
          initialState.startJourneySelectedErrorDraft,
        finishDateJourneySelectedErrorDraft:
          initialState.finishDateJourneySelectedErrorDraft,
        finishTimeJourneySelectedErrorDraft:
          initialState.finishTimeJourneySelectedErrorDraft,
        observaciones_instructor: initialState.observaciones_instructor,
        // Form Create Practice data 
        //selectedJourney: initialState.selectedJourney,
        //startDateTimeSelectedJourney: initialState.startDateTimeSelectedJourney,
        //startTimeSelectedJourneyPristine: initialState.startTimeSelectedJourneyPristine,
        //finishDateTimeSelectedJourney: initialState.finishDateTimeSelectedJourney,
        //finishTimeSelectedJourneyPristine: initialState.finishTimeSelectedJourneyPristine,
        startDateTimeSelectedPreparation:
          initialState.startDateTimeSelectedPreparation,
        startTimeSelectedPreparationPristine:
          initialState.startTimeSelectedPreparationPristine,
        //startDateTimeSelectedService: initialState.startDateTimeSelectedService,
        startTimeSelectedServicePristine: initialState.startTimeSelectedServicePristine,
        //finishDateTimeSelectedService: initialState.finishDateTimeSelectedService,
        finishTimeSelectedServicePristine: initialState.finishTimeSelectedServicePristine,
        minutesPracticeSelected: initialState.minutesPracticeSelected,
        stationSelected: initialState.stationSelected,
        destinySelected: initialState.destinySelected,
        //selectedInstructors: initialState.selectedInstructors,
        observaciones_alumno: initialState.observaciones_alumno,
        //selectedCourse: initialState.selectedCourse,
        //idTypePracticeSelected: initialState.idTypePracticeSelected,
        //typeServiceSelected: initialState.typeServiceSelected,
        vehicleSelected: initialState.vehicleSelected,
        trainSelected: initialState.trainSelected,
        //turnSelected: initialState.turnSelected,
        //jornada, instructor, curso, tipo de práctica, el tipo de servicio y turno
        //practicas seleccionadas para validar
        practiceValidSelect: initialState.practiceValidSelect,
      };
    
      case ActionTypes.RESET_START_CREATE_PRACTICE_FORM:
      return {
        ...state,
        error: state.error,
        msgSubmit: state.msgSubmit,
        modalDraftType: state.modalDraftType,
        username: state.username,
        password: state.password,
        profileSelected: state.profileSelected,
        // jorney, service, pd, minutes
        minutesPracticeSelectedError: initialState.minutesPracticeSelectedError,
        startServiceSelectedErrorDraft:
          initialState.startServiceSelectedErrorDraft,
        finishDateServiceSelectedErrorDraft:
          initialState.finishDateServiceSelectedErrorDraft,
        finishTimeServiceSelectedErrorDraft:
          initialState.finishTimeServiceSelectedErrorDraft,
        startPreparationSelectedError:
          initialState.startPreparationSelectedError,
        finishDateJourneySelectedError:
          initialState.finishDateJourneySelectedError,
        finishDateServiceSelectedError:
          initialState.finishDateServiceSelectedError,
        finishTimeJourneySelectedError:
          initialState.finishTimeJourneySelectedError,
        finishTimeServiceSelectedError:
          initialState.finishTimeServiceSelectedError,
        startJourneySelectedError: initialState.startJourneySelectedError,
        startServiceSelectedError: initialState.startServiceSelectedError,
        startJourneySelectedErrorDraft:
          initialState.startJourneySelectedErrorDraft,
        finishDateJourneySelectedErrorDraft:
          initialState.finishDateJourneySelectedErrorDraft,
        finishTimeJourneySelectedErrorDraft:
          initialState.finishTimeJourneySelectedErrorDraft,
        observaciones_instructor: initialState.observaciones_instructor,
        // Form Create Practice data 
        selectedJourney: initialState.selectedJourney,
        startDateTimeSelectedJourney: initialState.startDateTimeSelectedJourney,
        startTimeSelectedJourneyPristine: initialState.startTimeSelectedJourneyPristine,
        finishDateTimeSelectedJourney: initialState.finishDateTimeSelectedJourney,
        finishTimeSelectedJourneyPristine: initialState.finishTimeSelectedJourneyPristine,
        startDateTimeSelectedPreparation:
          initialState.startDateTimeSelectedPreparation,
        startTimeSelectedPreparationPristine:
          initialState.startTimeSelectedPreparationPristine,
        startDateTimeSelectedService: initialState.startDateTimeSelectedService,
        startTimeSelectedServicePristine:
          initialState.startTimeSelectedServicePristine,
        finishDateTimeSelectedService:
          initialState.finishDateTimeSelectedService,
        finishTimeSelectedServicePristine:
          initialState.finishTimeSelectedServicePristine,
        minutesPracticeSelected: initialState.minutesPracticeSelected,
        stationSelected: initialState.stationSelected,
        destinySelected: initialState.destinySelected,
        selectedInstructors: initialState.selectedInstructors,
        observaciones_alumno: initialState.observaciones_alumno,
        selectedCourse: initialState.selectedCourse,
        idTypePracticeSelected: initialState.idTypePracticeSelected,
        typeServiceSelected: initialState.typeServiceSelected,
        vehicleSelected: initialState.vehicleSelected,
        trainSelected: initialState.trainSelected,
        turnSelected: initialState.turnSelected,
      };


    case ActionTypes.RESET_CREATE_PRACTICE_FORM_ERROR:
      return {
        ...state,
        startJourneySelectedError: initialState.startJourneySelectedError,
        startJourneySelectedErrorDraft:
          initialState.startJourneySelectedErrorDraft,
        finishDateJourneySelectedError:
          initialState.finishDateJourneySelectedError,
        finishDateJourneySelectedErrorDraft:
          initialState.finishDateJourneySelectedErrorDraft,
        finishTimeJourneySelectedError:
          initialState.finishTimeJourneySelectedError,
        finishTimeJourneySelectedErrorDraft:
          initialState.finishTimeJourneySelectedErrorDraft,
        startPreparationSelectedError:
          initialState.startPreparationSelectedError,
        startServiceSelectedError: initialState.startServiceSelectedError,
        startServiceSelectedErrorDraft:
          initialState.startServiceSelectedErrorDraft,
        finishDateServiceSelectedError:
          initialState.finishDateServiceSelectedError,
        finishDateServiceSelectedErrorDraft:
          initialState.finishDateServiceSelectedErrorDraft,
        finishTimeServiceSelectedError:
          initialState.finishTimeServiceSelectedError,
        finishTimeServiceSelectedErrorDraft:
          initialState.finishTimeServiceSelectedErrorDraft,
        minutesPracticeSelectedError: initialState.minutesPracticeSelectedError,
      };

    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case ActionTypes.SET_USERNAME:
      return {
        ...state,
        username: action.payload,
      };

    case ActionTypes.SET_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };

    case ActionTypes.SET_USERNAME_PASSWORD:
      return {
        ...state,
        username: action.payload.username,
        password: action.payload.password,
      };

    case ActionTypes.SET_DATE_MIN_SELECTED:
      return {
        ...state,
        dateMinSelected: action.payload,
      };

    case ActionTypes.SET_DATE_MAX_SELECTED:
      return {
        ...state,
        dateMaxSelected: action.payload,
      };
    case ActionTypes.SET_STATE_PRACTICE_SELECTED:
      return {
        ...state,
        statePracticeSelected: action.payload,
      };
    case ActionTypes.SET_SELECTED_COURSES:
      return {
        ...state,
        selectedCourses: action.payload,
      };
    case ActionTypes.RESET_SELECTED_COURSES:
      return {
        ...state,
        selectedCourses: initialState.selectedCourses,
      };
    case ActionTypes.SET_SELECTED_COURSE:
      return {
        ...state,
        selectedCourse: action.payload || '',
      };
    case ActionTypes.SET_SELECTED_SOCIETIES:
      return {
        ...state,
        selectedSocieties: action.payload,
      };
    case ActionTypes.SET_SELECTED_INSTRUCTORS:
      return {
        ...state,
        selectedInstructors: action.payload,
      };
    case ActionTypes.SET_SELECTED_ALUMNO:
      return {
        ...state,
        selectedAlumnos: [...action.payload],
      };
    case ActionTypes.RESET_SELECTED_STUDENTS:
      return {
        ...state,
        selectedAlumnos: [...initialState.selectedAlumnos],
      };
    case ActionTypes.SET_PROFILE_SELECTED:
      return {
        ...state,
        profileSelected: action.payload,
      };
    case ActionTypes.SET_SELECTED_PROVINCE:
      return {
        ...state,
        selectedProvince: action.payload,
      };
    case ActionTypes.SET_PRACTICA_AUDITORIA_SELECCIONADA:
      return {
        ...state,
        practicaAuditoriaSeleccionada: action.payload,
      };
    case ActionTypes.SET_PRACTICA_RECLAMADA_SELECCIONADA:
      return {
        ...state,
        practicaReclamadaSeleccionada: action.payload,
      };
    case ActionTypes.SET_PRACTICA_RECHAZADA_SELECCIONADA:
      return {
        ...state,
        practicaRechazadaSeleccionada: action.payload,
      };

    case ActionTypes.SET_PRACTICA_VALIDADA_SELECCIONADA:
      return {
        ...state,
        practiceValidSelect: action.payload,
      };
    case ActionTypes.RESET_VALIDAR_PRACTICA_REQUEST:
      return {
        ...state,
        practiceValidSelect: initialState.practiceValidSelect,
      }; 
    // Form Crear/Editar práctica
    case ActionTypes.SET_JORNADA_SELECCIONADA:
      return {
        ...state,
        selectedJourney: action.payload,
      };
    case ActionTypes.SET_START_DATE_TIME_SELECTED_JOURNEY:
      if (!!action.payload) {
        removeSecondsAndMilliseconds(action.payload);
      }
      return {
        ...state,
        startDateTimeSelectedJourney: action.payload,
      };
    case ActionTypes.SET_START_TIME_SELECTED_JOURNEY_PRISTINE:
      return {
        ...state,
        startTimeSelectedJourneyPristine: action.payload,
      };
    case ActionTypes.SET_FINISH_DATE_TIME_SELECTED_JOURNEY:
      if (!!action.payload) {
        removeSecondsAndMilliseconds(action.payload);
      }
      return {
        ...state,
        finishDateTimeSelectedJourney: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_SELECTED_JOURNEY_PRISTINE:
      return {
        ...state,
        finishTimeSelectedJourneyPristine: action.payload,
      };
    case ActionTypes.SET_START_DATE_TIME_SELECTED_PREPARATION:
      if (!!action.payload) {
        removeSecondsAndMilliseconds(action.payload);
      }
      return {
        ...state,
        startDateTimeSelectedPreparation: action.payload,
      };
    case ActionTypes.SET_START_TIME_SELECTED_PREPARATION_PRISTINE:
      return {
        ...state,
        startTimeSelectedPreparationPristine: action.payload,
      };
    case ActionTypes.SET_START_DATE_TIME_SELECTED_SERVICE:
      if (!!action.payload) {
        removeSecondsAndMilliseconds(action.payload);
      }
      return {
        ...state,
        startDateTimeSelectedService: action.payload,
      };
    case ActionTypes.SET_START_TIME_SELECTED_SERVICE_PRISTINE:
      return {
        ...state,
        startTimeSelectedServicePristine: action.payload,
      };
    case ActionTypes.SET_FINISH_DATE_TIME_SELECTED_SERVICE:
      if (!!action.payload) {
        removeSecondsAndMilliseconds(action.payload);
      }
      return {
        ...state,
        finishDateTimeSelectedService: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE:
      return {
        ...state,
        finishTimeSelectedServicePristine: action.payload,
      };

    case ActionTypes.SET_FINISH_HOUR_SERVICE:
      return {
        ...state,
        hourService: action.payload,
      };

    case ActionTypes.SET_STATION_SELECTED:
      return {
        ...state,
        stationSelected: action.payload,
      };
    case ActionTypes.SET_DESTINY_SELECTED:
      return {
        ...state,
        destinySelected: action.payload,
      };
    case ActionTypes.SET_CREATION_SELECTED:
      return {
        ...state,
        creationSelected: action.payload,
      };
    case ActionTypes.SET_SELECTED_SCHOOL:
      return {
        ...state,
        selectedSchool: action.payload,
      };
    case ActionTypes.SET_INFO_USER_PROFILE_STATUS:
      return {
        ...state,
        infoUserProfileStatus: action.payload,
      };
    case ActionTypes.SET_UPDATE_INFO_USER_PROFILE:
      return {
        ...state,
        updateInfoUserProfileStatus: action.payload,
      };
    case ActionTypes.SET_ID_TYPE_PRACTICE_SELECTED:
      return {
        ...state,
        idTypePracticeSelected: action.payload,
      };
    case ActionTypes.SET_TYPE_PRACTICE_SELECTED:
      return {
        ...state,
        typePracticeSelected: action.payload,
      };
    case ActionTypes.SET_DISPOSICION_PRACTICE_SELECTED:
      return {
        ...state,
        disposicionPracticeSelected: action.payload,
      };
    case ActionTypes.SET_TYPE_SERVICE_SELECTED:
      return {
        ...state,
        typeServiceSelected: action.payload,
      };
    case ActionTypes.SET_VEHICLE_SELECTED:
      return {
        ...state,
        vehicleSelected: action.payload,
      };
    case ActionTypes.SET_TRAIN_SELECTED:
      return {
        ...state,
        trainSelected: action.payload,
      };
    case ActionTypes.SET_OBSERVATIONS_SELECTED:
      return {
        ...state,
        observacionesInstructorSelected:
          initialState.observacionesInstructorSelected,
      };

    case ActionTypes.SET_TURN_SELECTED:
      return {
        ...state,
        turnSelected: action.payload,
      };
    case ActionTypes.SET_STATE_TYPE:
      return {
        ...state,
        stateType: action.payload,
      };
    case ActionTypes.SET_PRACTICA_EDITAR:
      return {
        ...state,
        practicaEditar: action.payload,
      };
    case ActionTypes.SET_IS_AUDITAR:
      return {
        ...state,
        isAuditar: action.payload,
      };
    case ActionTypes.SET_MSG_SUBMIT:
      return {
        ...state,
        msgSubmit: action.payload,
      };
    case ActionTypes.SET_MODAL_DRAFT_TYPE:
      return {
        ...state,
        modalDraftType: action.payload,
      };
    case ActionTypes.SET_PRACTICA_CREADA:
      return {
        ...state,
        practicaCreada: action.payload,
      };

    case ActionTypes.SET_USER_LIST:
      return {
        ...state,
        userList: action.payload,
      };
    case ActionTypes.SET_OBSERVACIONES_INSTRUCTOR:
      return {
        ...state,
        observaciones_instructor: action.payload,
      };
    case ActionTypes.SET_OBSERVACIONES_ALUMNO:
      return {
        ...state,
        observaciones_alumno: action.payload,
      };
    case ActionTypes.SET_START_JOURNEY_SELECTED_ERROR:
      return {
        ...state,
        startJourneySelectedError: action.payload,
      };
    case ActionTypes.SET_START_JOURNEY_SELECTED_ERROR_DRAFT:
      return {
        ...state,
        startJourneySelectedErrorDraft: action.payload,
      };
    case ActionTypes.SET_FINISH_DATE_JOURNEY_SELECTED_ERROR:
      return {
        ...state,
        finishDateJourneySelectedError: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_JOURNEY_SELECTED_ERROR:
      return {
        ...state,
        finishTimeJourneySelectedError: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_JOURNEY_SELECTED_ERROR_DRAFT:
      return {
        ...state,
        finishTimeJourneySelectedErrorDraft: action.payload,
      };
    case ActionTypes.SET_START_SERVICE_SELECTED_ERROR:
      return {
        ...state,
        startServiceSelectedError: action.payload,
      };

    case ActionTypes.SET_START_PREPARATION_SELECTED_ERROR:
      return {
        ...state,
        startPreparationSelectedError: action.payload,
      };

    case ActionTypes.SET_START_SERVICE_SELECTED_ERROR_DRAFT:
      return {
        ...state,
        startServiceSelectedErrorDraft: action.payload,
      };
    case ActionTypes.SET_FINISH_DATE_SERVICE_SELECTED_ERROR:
      return {
        ...state,
        finishDateServiceSelectedError: action.payload,
      };

    case ActionTypes.SET_FINISH_DATE_SERVICE_SELECTED_ERROR_DRAFT:
      return {
        ...state,
        finishDateServiceSelectedErrorDraft: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_SERVICE_SELECTED_ERROR:
      return {
        ...state,
        finishTimeServiceSelectedError: action.payload,
      };
    case ActionTypes.SET_FINISH_TIME_SERVICE_SELECTED_ERROR_DRAFT:
      return {
        ...state,
        finishTimeServiceSelectedErrorDraft: action.payload,
      };
    // Alert
    case ActionTypes.SET_ALERT:
      return {
        ...state,
        alert: action.payload,
      };
    // Loading
    case ActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ActionTypes.RESET_SELECTED_SERVICES_AND_JOURNEYS:
      return {
        ...state,
        minutesPracticeSelectedError: initialState.minutesPracticeSelectedError,
        minutesPracticeSelected: initialState.minutesPracticeSelected,
        startDateTimeSelectedJourney: initialState.startDateTimeSelectedJourney,
        finishDateTimeSelectedJourney:
          initialState.finishDateTimeSelectedJourney,
        startDateTimeSelectedService: initialState.startDateTimeSelectedService,
        finishDateTimeSelectedService:
          initialState.finishDateTimeSelectedService,
        startServiceSelectedErrorDraft:
          initialState.startServiceSelectedErrorDraft,
        finishDateServiceSelectedErrorDraft:
          initialState.finishDateServiceSelectedErrorDraft,
        finishTimeServiceSelectedErrorDraft:
          initialState.finishTimeServiceSelectedErrorDraft,
        startPreparationSelectedError:
          initialState.startPreparationSelectedError,
        finishDateJourneySelectedError:
          initialState.finishDateJourneySelectedError,
        finishDateServiceSelectedError:
          initialState.finishDateServiceSelectedError,
        finishTimeJourneySelectedError:
          initialState.finishTimeJourneySelectedError,
        finishTimeServiceSelectedError:
          initialState.finishTimeServiceSelectedError,
        startJourneySelectedError: initialState.startJourneySelectedError,
        startServiceSelectedError: initialState.startServiceSelectedError,
        startJourneySelectedErrorDraft:
          initialState.startJourneySelectedErrorDraft,
        finishDateJourneySelectedErrorDraft:
          initialState.finishDateJourneySelectedErrorDraft,
        finishTimeJourneySelectedErrorDraft:
          initialState.finishTimeJourneySelectedErrorDraft,
      };
    // minutes
    case ActionTypes.SET_MINUTES_PRACTICE_SELECTED:
      return {
        ...state,
        minutesPracticeSelected: action.payload,
      };
    case ActionTypes.SET_MINUTES_PRACTICE_SELECTED_ERROR:
      return {
        ...state,
        minutesPracticeSelectedError: action.payload,
      };
    case ActionTypes.SET_MINUTES_CE_SELECTED:
      return {
        ...state,
        minutesCESelected: action.payload,
      };
    case ActionTypes.SET_MINUTES_PENDING_CE_SELECTED:
      return {
        ...state,
        minutesPendingCESelected: action.payload,
      };
    case ActionTypes.SET_MINUTES_OTHER_SELECTED:
      return {
        ...state,
        minutesOtherSelected: action.payload,
      };
    case ActionTypes.SET_MINUTES_PENDING_OTHER_SELECTED:
      return {
        ...state,
        minutesPendingOtherSelected: action.payload,
      };

    case ActionTypes.SET_MINUTES_DRAFT_SELECTED:
      return {
        ...state,
        minutesDraftSelected: action.payload,
      };
    case ActionTypes.SET_MINUTES_PREPARATION_SELECTED:
      return {
        ...state,
        minutesPreparationSelected: action.payload,
      };

    default:
      return state;
  }
};

const persistConfig = {
  key: 'app',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    'error',
    'selectedCourses',
    'selectedCurso',
    'selectedProvince',
    'practicaAuditoriaSeleccionada',
    'practicaReclamadaSeleccionada',
    'practicaRechazadaSeleccionada',
    'selectedJourney',
    'startDateTimeSelectedJourney',
    'finishDateTimeSelectedJourney',
    'startDateTimeSelectedService',
    'finishDateTimeSelectedService',
    'startJourneySelectedError',
    'finishDateJourneySelectedError',
    'finishTimeJourneySelectedError',
    'startServiceSelectedError',
    'finishDateServiceSelectedError',
    'finishTimeServiceSelectedError',
    'minutesTimeEndServiceSelected',
    'minutesTimeEndServiceSelectedError',
    'stationSelected',
    'destinySelected',
    'minutesPracticeSelected',
    'typePracticeSelected',
  ],
};

export default persistReducer(persistConfig, reducer);
